var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"position-relative",class:{'disabled': _vm.disabled},attrs:{"variant":"primary","block":""},on:{"click":function($event){return _vm.download()}}},[_vm._v(_vm._s(_vm.labelToDisplay)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }